import Api from './Api';

const END_POINT = 'categories';

export default{
    async get_all (filters) {
        let request = {
            params: filters
        }
        return await Api.get(`${END_POINT}`, request);
    }
}